<div class="driver-modal">
  <div class="sec_head">
    <h2>{{ (data.data ? 'EditArea' : 'AddArea') | translate }}</h2>
    <button class="btnn close_icon" [mat-dialog-close]="true">
      <mat-icon>close</mat-icon>
    </button>
  </div>
  <div class="modal-body">
    <form
      class="attribute-modal"
      [formGroup]="addAreaForm"
      (ngSubmit)="onSubmit()">
      <div class="form_feilds gap_m">
        <div class="form_group w_100">
          <mat-label class="required"> {{ 'AreaName' | translate }}</mat-label>
          <mat-form-field appearance="fill">
            <input
              matInput
              formControlName="name"
              placeholder=" {{ 'EnterHere' | translate }}"
              class="form_control" />
          </mat-form-field>
          <mat-error
            *ngIf="
              submitted && addAreaForm.controls['name'].hasError('required')
            ">
            {{ 'name' | translate }}
            {{ 'IsRequired' | translate }}
          </mat-error>
          <mat-error
            *ngIf="
              submitted && addAreaForm.controls['name'].hasError('maxlength')
            ">
            {{ 'name' | translate }}
            {{ 'Upto40Char' | translate }}
          </mat-error>
          <mat-error
            *ngIf="
              submitted && addAreaForm.controls['name'].hasError('minlength')
            ">
            {{ 'name' | translate }}
            {{ 'Atleast3Char' | translate }}
          </mat-error>
        </div>
        <!-- <div class="form_group geo_fence_btn mb_20">
          <button
            type="button"
            class="btnn btn_primary removeBtn"
            (click)="deletePolygon()">
            {{ 'Remove' | translate }}
          </button>
        </div> -->
      </div>
      <!-- <div class="my_50">
        <div id="map" style="padding: 20em; display: flex"></div>
      </div> -->
      <div class="submit_btn">
        <button type="submit" class="btnn btn_primary">
          {{ 'Submit' | translate }}
        </button>
      </div>
    </form>
  </div>
</div>
